import { z } from "zod";

export const createDataSourceSchema = z
  .object({
    name: z
      .string()
      .min(1, "Name is required")
      .max(255, "Name must be 255 characters or less"),
    url: z.string().min(1, "URL is required").url("Must be a valid URL"),
    user_id: z.string().min(1, "User ID is required"),
    query_param: z.boolean(),
    header: z.boolean(),
    include_headers: z.boolean(),
    headers: z.array(
      z.object({
        key: z.string(),
        value: z.string(),
      })
    ),
  })
  .refine((data) => data.query_param || data.header, {
    message: "Select at least one method to send User ID",
    path: ["query_param"],
  });

export type CreateDataSourceFormData = z.infer<typeof createDataSourceSchema>;
